import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import FYSelect from "@/components/FYSelect";
import { loadFinancialYears, fyLabel } from "@/lib/fy";

export default function TrainingsList() {
  const [items, setItems] = useState([]);
  const [fy, setFy] = useState(undefined);

  useEffect(() => {
    loadFinancialYears().then((d) => setFy((prev) => (prev === undefined ? d.current_fy : prev)));
  }, []);

  useEffect(() => {
    if (fy === undefined) return;
    const params = fy === null ? {} : { fy };
    api.get("/trainings", { params }).then((r) => setItems(r.data));
  }, [fy]);

  return (
    <div data-testid="trainings-page">
      <PageHeader
        eyebrow="Training Records"
        title="Conducted trainings"
        subtitle={`Auditable record of every training session conducted. Showing ${fyLabel(fy ?? null)}.`}
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Trainings" }]}
        action={<FYSelect value={fy ?? null} onChange={setFy} allowAllTime testid="trainings-fy-select" />}
      />
      <div className="px-4 md:px-10 py-8">
        <div className="bc-card overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-[#F9F9F9] border-b border-[#E5E5E5]">
                <th className="text-left px-5 py-2.5 bc-label">ID</th>
                <th className="text-left px-5 py-2.5 bc-label">Skill</th>
                <th className="text-left px-5 py-2.5 bc-label">Date</th>
                <th className="text-left px-5 py-2.5 bc-label">Trainer</th>
                <th className="text-left px-5 py-2.5 bc-label">Mode</th>
                <th className="text-left px-5 py-2.5 bc-label">Attendees</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (
                <tr><td colSpan="7" className="px-5 py-8 text-center text-[#666666]">No trainings conducted yet.</td></tr>
              )}
              {items.map((t) => (
                <tr key={t.training_id} className="border-b border-[#E5E5E5] bc-row-hover">
                  <td className="px-5 py-2.5 font-mono text-xs">{t.training_id}</td>
                  <td className="px-5 py-2.5 font-medium">{t.skill_name}</td>
                  <td className="px-5 py-2.5 font-mono text-xs">{t.date_conducted}</td>
                  <td className="px-5 py-2.5">{t.trainer_name}</td>
                  <td className="px-5 py-2.5 capitalize">{t.mode}</td>
                  <td className="px-5 py-2.5 font-mono">{t.attendance.filter((a) => a.present).length}/{t.attendance.length}</td>
                  <td className="px-5 py-2.5 text-right">
                    <Link to={`/calendar/${t.calendar_id}`} className="text-xs text-[#C41E1E] font-medium">Open →</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
